import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import { Button } from '~/components/Buttons'

import * as S from '../../styles'
import { DefaultError } from '../index'
import { ErrorItem } from '../types'

type ValidationErrorsProps = {
  errors: ErrorItem[]
  onBack: () => void
}

export const ValidationErrors = ({ errors, onBack }: ValidationErrorsProps) => {
  return (
    <S.ErrorContainer>
      <S.ErrorListContainer>
        <S.ErrorItemWrapper>
          <Alert variant="critical">
            {t('rm:externalCampaignMetrics.form.validation_error.title')}
          </Alert>
        </S.ErrorItemWrapper>
        {errors.map((errorItem, index) => (
          <S.ErrorItemWrapper key={index}>
            <DefaultError error={errorItem} />
          </S.ErrorItemWrapper>
        ))}
      </S.ErrorListContainer>

      <S.ButtonContainer>
        <Button
          text={t('rm:externalCampaignMetrics.form.error.back')}
          template="primary"
          onClick={onBack}
        />
      </S.ButtonContainer>
    </S.ErrorContainer>
  )
}
